import { useEffect, useState, useCallback } from "react";
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
    useIsAuthenticated,
    useAccount
} from "@azure/msal-react";
import axios from "axios"
import authConfig from "../../authConfig";
import Button from 'react-bootstrap/Button';
import { FaDownload } from 'react-icons/fa';
import { useSelector, useDispatch } from "react-redux";
//import { setLoginState, logout } from "../../redux/authSlice";

function SecureFileLink(props) {
    // new optional props: allowdownload (default true), variant (default 'success'), className (default '')
    const { allowdownload = true, variant = 'success', className = '' } = props;
    const isAuthenticated = useIsAuthenticated();
    const isMemberLoggedIn = useSelector(state => state.auth.isLoggedIn);
    const { instance, accounts } = useMsal()
    const account = useAccount(accounts[0] || {})
    const [loading, setLoading] = useState(false);

    async function handleDownload(downloadfile) {
        // Open window immediately (before async operations) to avoid popup blocker
        let newWindow = null;
        if (!downloadfile) {
            newWindow = window.open('', '_blank');
            if (newWindow) {
                //newWindow.document.write('Loading...');
            }
        }

        let authresponse = null;
        let returnvalue = null;
        //setLoading(true);
        if (isAuthenticated) {
            //console.log("#1",account,loading);
            if (account && loading == false) {
                setLoading(true)
                //console.log("#2");
                await instance
                    .acquireTokenSilent({
                        scopes: authConfig.api.scopes,
                        account: account
                    })
                    .then(response => {
                        authresponse = response;
                        console.log("authresponse :)")
                        setLoading(false);
                    })
                    .catch(error => {
                        //setError("Error getting token: " + error.message)
                        //console.error(error)
                        console.log("authresponse fail :(")
                        setLoading(false);
                    });
            }
        }

        //let file = props.url;//'https://www.example.com/some-file.pdf';

        let headers = new Headers();
        if (authresponse) {
            headers.append('Authorization', 'Bearer ' + authresponse.accessToken);
        } else 
        {
            //console.log("AUTHRESPONSENULL");

        }
        const fetchOptions = { headers };
        let targeturl = props.url;
        if (isMemberLoggedIn) {
            console.log("SECLINK-MEMBERLOGGEDIN")
            fetchOptions.credentials = 'include';
            targeturl = targeturl.replace(authConfig.api.urls.getMeetingSecureFileForMemberFrom, authConfig.api.urls.getMeetingSecureFileForMemberTo)
        }

        fetch(targeturl, fetchOptions)
            .then(response => response.blob())
            .then(blobby => {
                // Determine MIME type based on file extension
                let mimeType = 'application/octet-stream'; // default
                if (props.filename) {
                    const extension = props.filename.toLowerCase().split('.').pop();
                    const mimeTypes = {
                        'pdf': 'application/pdf',
                        'jpg': 'image/jpeg',
                        'jpeg': 'image/jpeg',
                        'png': 'image/png',
                        'gif': 'image/gif',
                        'doc': 'application/msword',
                        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'xls': 'application/vnd.ms-excel',
                        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'txt': 'text/plain',
                        'csv': 'text/csv'
                    };
                    mimeType = mimeTypes[extension] || mimeType;
                }

                // Create blob with correct MIME type
                let blob = new Blob([blobby], { type: mimeType });
                let objectUrl = window.URL.createObjectURL(blob);

                if (!downloadfile) {
                    if (newWindow && !newWindow.closed) {
                        console.log("newwin")
                        // Write HTML to display the PDF/file
                        newWindow.document.write(`
                            <!DOCTYPE html>
                            <html>
                            <head>
                                <title>${props.filename || 'File'}</title>
                                <style>
                                    body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; }
                                    iframe { border: none; width: 100%; height: 100%; }
                                </style>
                            </head>
                            <body>
                                <iframe src="${objectUrl}" type="${mimeType}"></iframe>
                            </body>
                            </html>
                        `);
                        newWindow.document.close();
                    } else {
                        // Fallback if window was blocked
                        window.open(objectUrl, "_blank");
                    }
                    // Don't revoke URL for viewing - browser will clean up when tab closes
                    // Revoking too early causes the tab to close/lose content
                } else {
                    let anchor = document.createElement("a");
                    document.body.appendChild(anchor);
                    anchor.href = objectUrl;
                    anchor.download = props.filename;
                    anchor.click();
                    document.body.removeChild(anchor);
                    // Revoke after download completes
                    setTimeout(() => {
                        window.URL.revokeObjectURL(objectUrl);
                    }, 1000);
                }
            })
            .catch(error => {
                console.error("Error fetching file:", error);
                if (newWindow && !newWindow.closed) {
                    newWindow.close();
                }
            });
    }
    return (
        <>
            {props.type && props.type === "button" ?
                (
                    <Button size="sm" variant={variant} className={className} onClick={() => { handleDownload(false); }}>{props.children}</Button>) :
                (
                    <a href="#" onClick={(e) => { e.preventDefault(); handleDownload(false); }}>{props.children}</a>)
            }
            {allowdownload && <>&nbsp;</>}
            {allowdownload && <Button size="sm" variant={variant} className={className} onClick={() => { handleDownload(true); }}><FaDownload /></Button>}
        </>
    )
}
export default SecureFileLink;